// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"privacy-policy_PrivacyPolicy__rdMBW","content":"privacy-policy_content__yVpJo"};